import BigNumber from 'bignumber.js';
import Base from './Base';
BigNumber.config({ EXPONENTIAL_AT: 1e9 });

export default class VolumeUnit extends Base {}
